import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

//get some normalized state
//work data that has an ids array and then also has entities
const userAdapter = createEntityAdapter({});
const initialState = userAdapter.getInitialState();

//injection into original slice
//RTKQuery create an hook based on this endpoint for use
export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query({
      query: () => "/user",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError; //make sure isn't error
      },
      providesTags: (result, error, arg) => {
        //just fail safte
        if (result) {
          return [{ type: "User" }];
        } else {
          return [{ type: "User" }];
        }
      },
    }),
    updateUserEmail: builder.mutation({
      query: ({ newEmail }) => ({
        url: "/user/account/email",
        method: "PATCH",
        body: {
          newEmail,
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "User" }],
    }),
    updateUserPassword: builder.mutation({
      query: (initialUserData) => ({
        url: "/user/account/password",
        method: "PUT",
        body: {
          ...initialUserData,
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "User" }],
    }),
    updateUserProfile: builder.mutation({
      query: ({ username, image }) => ({
        url: "/user/profile",
        method: "PUT",
        body: {
          username,
          image,
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "User" }],
    }),
    deleteUser: builder.mutation({
      query: ({ id }) => ({
        url: `/user`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "User" }],
    }),
  }),
});

export const {
  useGetUserQuery,
  useUpdateUserEmailMutation,
  useUpdateUserPasswordMutation,
  useUpdateUserProfileMutation,
  useDeleteUserMutation,
} = userApiSlice;

// returns the query result object
export const selectUserResult = userApiSlice.endpoints.getUser.select();

// creates memoized selector
const selectUserData = createSelector(
  selectUserResult,
  (userResult) => userResult.data // normalized state object with ids & entities
);

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  //selectAll: selectAllUser,
  selectById: selectUserById,
  //selectIds: selectUserIds,
  // Pass in a selector that returns the users slice of state
  //?? : return the right hand value if left hand value is undefined and null
} = userAdapter.getSelectors((state) => selectUserData(state) ?? initialState);
